<template>
    <div class="community__cards">
        <div class="o-wrapper">
            <div v-if="showPlaceholders || !!cards.length" class="o-grid">
                <div class="o-grid__item u-width-full">
                    <div id="cardsWrapper" class="cards__wrapper">
                        <content-placeholders
                            v-if="showPlaceholders"
                        ></content-placeholders>
                        <div
                            class="cards"
                            id="cards"
                            data-cy="community-cards"
                        >
                            <post-card-api
                                v-for="card in cards"
                                :key="card.id"
                                :card="card"
                            ></post-card-api>
                            <template v-for="index in 8" v-if="showPagingPlaceHolders">
                                <content-placeholder
                                ></content-placeholder>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="showEmptyState" class="search__no-results">
            <div>
                <h1>Search for community content</h1>
                <p>Enter a search term to find content across {{ $root.brand.name }} communities.</p>
            </div>
        </div>
        <div v-if="showNoResults" class="search__no-results">
            <div>
                <h1 v-html="noResultsTitle"></h1>
                <p v-html="noResultsContent"></p>
            </div>
        </div>
    </div>
</template>

<script>
import PostCardApi from "../PostCardApi";
import MasonryStore from "../../configs/masonry-store";
import ContentPlaceholder from "../ContentPlaceholder";
import ContentPlaceholders from "../ContentPlaceholders";

export default {
    components: {
        PostCardApi,
        ContentPlaceholder,
        ContentPlaceholders
    },
    data() {
        return {
            cards: [],
            loading: false,
            loadedSession: false,
            masonry: MasonryStore,
            next: true,
            noResultsContent: 'Please try searching again using a combination of words or phrases.',
            noResultsTitle: 'No content found',
            page: 1,
            scrollTo: 0,
            showEmptyState: this.$root.$route.name === 'contentSearch',
            showPlaceholders: false,
            showNoResults: false,
            showPagingPlaceHolders: false,
            type: 'all'
        };
    },
    watch: {
        cards() {
            this.$nextTick(() => this.masonry.images());
        },
        $route(to, from) {
            this.cards = [];
            this.page = 1;
            this.fetchData();
            this.masonry.load();
        },
    },
    created() {
        this.$root.$on('bus-communitycards-initial-placeholder', () => {
            this.blankCards();
            this.showEmptyState = false;
            this.showPlaceholders = true;
        });
        this.$root.$on('bus-communitycards-paging-placeholders', () => {
            this.showPlaceholders = false;
            this.showPagingPlaceHolders = true;
            this.$nextTick(() => this.masonry.images());
        });
        this.$root.$on('bus-communitycards-paging-placeholders-off', () => {
            this.showPlaceholders = false;
            this.showPagingPlaceHolders = false;
            this.$nextTick(() => this.masonry.images());
        });
        // update content cards on hashchange
        window.addEventListener(
            'hashchange',
            () => {
                let hash = this.$simpleStore.getHash(true);
                if (hash.length > 1) {
                    this.resetCards();
                }
            },
            false
        );
    },
    mounted() {
        // fetch the data when the view is created and the data is
        // already being observed
        if (this.$root.$route.name !== 'contentSearch') {
            this.fetchData();
            this.scrollPosts();
        }
        this.$root.$on('bus-communitycards-update', this.updateCards);
        this.$root.$on('bus-communitycards-add', this.addCards);
        this.$root.$on('bus-communitycards-reset', this.resetCards);
        this.$root.$on('bus-communitycards-blank', this.blankCards);
        this.$root.$on('bus-communitycards-search-noresults', (term) => {
            this.cards = [];
            this.showPlaceholders = false;
            this.showNoResults = true;
            this.noResultsTitle = 'No results found';
            this.noResultsContent = 'No content matches <strong>' + (term || 'your search') + '</strong> in this community.';
        });
        console.log(this.$route.name);
    },
    updated() {
        //async(onYouTubeIframeAPIReady);
        this.$nextTick(() => {
            if (this.loadedSession && this.scrollTo > 0) {
                window.onload = () => {
                    // wait 250 ms to allow Isotope to reload
                    setTimeout(() => {
                        window.scrollTo(0, this.scrollTo);
                    }, 250);
                    this.loadedSession = false;
                };
            }
        });
    },
    methods: {
        showMemberPanel() {
            this.$simpleStore.showMemberPanel(this);
        },
        getSessionName() {
            // v2: bump when card data shape changes to bust stale sessionStorage
            const SESSION_VERSION = 'v4';
            let hashtag = this.$simpleStore.getHash(true);
            return (
                'c' + '-' + SESSION_VERSION + '-' + this.type + '-' +
                this.$root.community.id +
                (hashtag.length > 1 ? '-h-' + hashtag : '')
            );
        },
        getSession(resetSession = false) {
            if (this.$root.$route.name === 'contentSearch') {
                return [];
            }
            const currentTimestamp = Math.floor(Date.now() / 1000);
            let sessionName = this.getSessionName();
            let session = sessionStorage.getItem(sessionName)
                ? JSON.parse(sessionStorage.getItem(sessionName))
                : null;
            let timestamp = session != null ? session[0].timestamp : 0;
            //console.log((currentTimestamp - timestamp), currentTimestamp, timestamp, this.$simpleStore.sessionTTL);
            if (
                resetSession === true ||
                timestamp == null ||
                currentTimestamp - timestamp > this.$simpleStore.sessionTTL
            ) {
                sessionStorage.removeItem(sessionName);
                return [
                    {
                        cards: [],
                        timestamp: 0,
                        page: 1,
                        scroll: 0,
                        next: true,
                    },
                ];
            }
            return session;
        },
        setSession() {
            if (this.$root.$route.name === 'contentSearch') {
                return;
            }
            const currentTimestamp = Math.floor(Date.now() / 1000);
            let session = [
                {
                    cards: [],
                    timestamp: 0,
                    page: 0,
                    scroll: 0,
                },
            ];
            let sessionName = this.getSessionName();
            if (sessionStorage.getItem(sessionName)) {
                session = JSON.parse(sessionStorage.getItem(sessionName));
            }
            for (let i = 0; i < this.cards.length; i++) {
                let postCard = {};
                for (let j in this.cards[i]) {
                    if (this.cards[i][j] != null) {
                        postCard[j] = this.cards[i][j];
                    }
                }
                if (
                    session[0].cards == null ||
                    session[0].cards.find(
                        (x) => x.dyadey_id === postCard.dyadey_id
                    ) == null
                ) {
                    try {
                        session[0].cards.push(postCard);
                    } catch (err) {
                        console.log('Error:');
                        console.log(err);
                    }
                }
            }
            if (session[0].timestamp === 0) {
                session[0].timestamp = currentTimestamp;
            }
            session[0].page = this.page;
            session[0].next = this.next;
            sessionStorage.setItem(sessionName, JSON.stringify(session));
        },
        setSessionScroll(scrollHeight) {
            let sessionName = this.getSessionName();
            if (sessionStorage.getItem(sessionName)) {
                let session = JSON.parse(sessionStorage.getItem(sessionName));
                session[0].scroll = scrollHeight;
                sessionStorage.setItem(sessionName, JSON.stringify(session));
            }
        },
        fetchData(resetSession = false) {
            if (resetSession === true) {
                this.cards = null;
            }
            switch (this.$root.$route.name) {
                case 'communityOfficialPosts':
                    this.type = 'official';
                    break;

                case 'communityArticlePosts':
                    this.type = 'articles';
                    break;

                case 'communityReposts':
                    this.type = 'reposts';
                    break;

                default:
                    this.type = 'all';
            }
            let session = this.getSession(resetSession);
            // if there are valid cards in the session display them and do no requests
            if (this.page === 1 && session[0].cards.length > 0) {
                // scroll to previous position from session data using update() function
                this.loadedSession = true;
                this.scrollTo = session[0].scroll;
                this.cards = session[0].cards;
                this.page = session[0].page;
                this.next = session[0].next !== undefined ? session[0].next : true;
                return;
            }
            let params = {
                page: this.page,
                type: this.type
            };
            if (typeof this.$route.params.community != 'undefined') {
                params.community_url = this.$route.params.community;
            }
            let hashTag = this.$simpleStore.getHash(true);
            if (hashTag.length > 1) {
                params.hashtag = hashTag;
            }
            this.loading = true;
            if (this.page === 1) {
                this.showPlaceholders = true;
                this.masonry.images();
            } else {
                this.showPlaceholders = false;
                this.showPagingPlaceHolders = true;
                this.masonry.images();
            }
            console.log('this.showPlaceholders', this.showPlaceholders);
            console.log('this.showPagingPlaceHolders', this.showPagingPlaceHolders);
            this.$http.post('/api/v1/posts', params).then((response) => {
                const newCards = response.data.cards;
                if (this.cards == null) {
                    this.cards = newCards;
                } else {
                    this.cards.push.apply(this.cards, newCards);
                }
                this.showNoResults = this.cards.length === 0;
                if (this.$route.name !== 'contentSearch') {
                    if (this.$route.name === 'communityReposts') {
                        this.noResultsTitle = 'No reposts yet';
                        this.noResultsContent = 'No articles have been reposted to this community yet.';
                    } else {
                        this.noResultsTitle = 'No articles added';
                        this.noResultsContent = 'No articles have been added to this community yet.';
                    }
                }
                this.showPlaceholders = false;
                this.showPagingPlaceHolders = false;
                this.next = response.data.page < response.data.total_pages;
                this.page++;
                this.loading = false;
                this.setSession();
            },
            (response) => {
                console.log('Errored:');
                console.log(response);
                this.loading = false;
                this.showPlaceholders = false;
                this.showPagingPlaceHolders = false;
            });
        },
        scrollPosts() {
            let isScrolling;
            window.addEventListener('scroll', () => {
                // if there is an active content search do not scroll
                if (
                    typeof this.$root.search != 'undefined' &&
                    this.$root.search.length > 0
                ) {
                    return;
                }
                let scrollHeight = Math.max(
                    window.scrollY,
                    document.documentElement.scrollTop,
                    document.body.scrollTop
                );
                window.clearTimeout(isScrolling);
                // Only update session scroll after scrolling ends
                isScrolling = setTimeout(() => {
                    this.setSessionScroll(scrollHeight);
                }, 66);
                // only calculate scroll height when not loading and when there are more posts to load
                if (this.loading === false && this.next) {
                    let percentageScroll =
                        (scrollHeight + window.innerHeight) /
                        document.documentElement.offsetHeight;
                    // load more posts when scrolled 90% of screen height
                    if (percentageScroll > 0.9) {
                        this.fetchData();
                    }
                }
            });
        },
        resetCards() {
            this.page = 1;
            this.fetchData(true);
            this.masonry.load();
        },
        blankCards() {
            this.cards = [];
            this.showNoResults = false;
            this.masonry.load();
            if (this.$route.name === 'contentSearch') {
                this.showEmptyState = true;
            }
        },
        updateCards(data) {
            this.showEmptyState = false;
            this.showPlaceholders = false;
            if (data.cards.length === 0) {
                this.showNoResults = true;
            } else {
                this.cards.push.apply(this.cards, data.cards);
            }
        },
        addCards(data) {
            this.showEmptyState = false;
            this.cards = [];
            this.next = data.cards.length > 0;
            this.page = data.page;
            this.showPlaceholders = false;
            this.cards.push.apply(this.cards, data.cards);
        },
    },
};
</script>
